import React from 'react';
import './TestiItem.css';

const TestiItem = () => {
    return (
        <div className="container_third_item">

            <h2><span className="container_third--blog"> <span className="normal"> John
            Smith </span></span></h2>

            <p className="container_third--text">Lorem ipsum dolor sit amet consectetur
                adipisicing elit. Adipisci magni tenetur nobis velit quasi sequi
                quod. Praesentium iure repellendus corrupti ab unde, aliquam
                possimus similique esse. Incidunt inventore similique eveniet.
            </p>

        </div>
    )
}

export default TestiItem;